import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout, firebase_update, firebase_get_device_client_title} from "./firebase";

import Level from "./guages/level";
import Pressure from "./guages/pressure";
import Temp from "./guages/temp";
import Heat from "./guages/heat";
import GasLeak from "./guages/gasleak";
import Vaporizer from "./guages/vaporizer";

import Map from "./components/map";


import { useLocation } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import FaceIcon from '@mui/icons-material/Face';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { Form, Field } from 'react-final-form';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";

import Avatar from '@mui/material/Avatar';


import LPGTangFull  from "./images/gas_full.svg";
import LPGTangFullShared  from "./images/gas_full-shared.svg";
import LPGTang34  from "./images/gas_3_4.svg";
import LPGTang12  from "./images/gas_1_2.svg";
import LPGTang12Shared  from "./images/gas_1_2-shared.svg";
import LPGTang14  from "./images/gas_1_4.svg";
import LPGTang14Shared  from "./images/gas_1_4-shared.svg";

import LPGTangAlarm  from "./images/gas_alarm.svg";

import LPGTangDeactivated  from "./images/gas_deactivated.svg";
import LPGTangDeactivatedShared  from "./images/gas_deactivated-shared.svg";
import LPGTangDeactivatedNA  from "./images/gas_deactivated_na.svg";
import LPGTangDeactivatedNAShared  from "./images/gas_deactivated_na-shared.svg";

import LPGTangFullOnline  from "./images/gas_full_online.svg";
import LPGTangFullOnlineShared  from "./images/gas_full_online-shared.svg";
import LPGTang34Online  from "./images/gas_3_4_online.svg";
import LPGTang34OnlineShared  from "./images/gas_3_4_online-shared.svg";
import LPGTang12Online  from "./images/gas_1_2_online.svg";
import LPGTang12OnlineShared  from "./images/gas_1_2_online-shared.svg";
import LPGTang14Online  from "./images/gas_1_4_online.svg";
import LPGTang14OnlineShared  from "./images/gas_1_4_online-shared.svg";

import LPGTangAlarmOnline  from "./images/gas_alarm_online.svg";

import GasStorageEmpty from "./images/gasStorage_empty.svg";
import GasStorageEmptyShared from "./images/gasStorage_empty-shared.svg";
import GasStorageDeplete from "./images/gasStorage_deplete.svg";
import GasStorageDepleteShared from "./images/gasStorage_deplete-shared.svg";
import GasStorageGood from "./images/gasStorage_good.svg";
import GasStorageGoodShared from "./images/gasStorage_good-shared.svg";
import GasStorageFull from "./images/gasStorage_full.svg";
import GasStorageFullShared from "./images/gasStorage_full-shared.svg";
import GasStorageDeactivated from "./images/gas-storage-deactivated.svg";
import GasStorageDeactivatedShared from "./images/gas-storage-deactivated-shared.svg";


import pressureDeplete from "./images/valve_deplete.svg";
import pressureActive from "./images/valve_active.svg";
import pressureStandby from "./images/valve_standby.svg";


//import useWindowScroll from "@react-hook/window-scroll";

import { useSpring, animated } from 'react-spring'


import Styles from './Styles';

import {styled} from "@mui/system";
import { keyframes } from '@mui/system';
import { red } from "@mui/material/colors";
import { StayPrimaryLandscape } from "@mui/icons-material";
import moment from "moment";


function DeviceStatus(props){
  //console.log(props.sharedDevice)

  const history = useHistory();

  const r = '/devices/' + props.deviceId;

  const [device_snapshot, loading_device, error_db] = useObject(db.ref(r));

  const [formats, setFormats] = React.useState(() => ['activated']);

  const [device, setDevice] = useState();
  const [clientTitle, setClientTitle] = useState();
  
  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  const blink = keyframes`
      from { opacity: 0; }
      to { opacity: 1; }
    `;

  const BlinkedBox = styled('div')({
      backgroundColor: 'red',
      width: 30,
      height: 30,
      animation: `${blink} 1s linear infinite`,
    });

  useEffect(() => {
    //console.log("share?? "+props.shared)
      if(device_snapshot && !loading_device)
      {
        setDevice(device_snapshot.val());
      }
  }, [device_snapshot, loading_device]);


  if (loading_device)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Fetching device data...
              </Typography>
            </Box>
            </div>);
  }

  const onSubmit = async values => {
   
}

const handleFormat = (event, newFormats) => {
  var a = newFormats.filter(value => value === 'activated');
  var b = newFormats.filter(value => value === 'online');
  var c = newFormats.filter(value => value === 'email');
  //alert(a + ' ' + b + ' ' + c)
  //alert((a == 'activated') + ' ' + (b == 'online') + ' ' + (c == 'email'));
  /*firebase_update_device(device.id, 
    { 
      status: {
        activated: (a == 'activated').toString(),
        online: (b == 'online').toString(),
        email: (c == 'email').toString(),
      }
    });
    setFormats(newFormats);*/
  };

const showDevice = (deviceId, uid) => {
    history.push(
        { pathname: '/device',
          state: {
              deviceId: deviceId,
              uid: uid,
          }
        });
}

const updateDevice = (deviceId) => {
    history.push(
        { pathname: '/update_device',
          state: {
              deviceId: deviceId,
          }
        });
}

const getLPGTang = () => 
{
  if(device.type == 'tank'){
    if(device.status.activated==="false")
    {
      return <img
              src={(props.shared=='true') ? GasStorageDeactivatedShared : GasStorageDeactivated}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 120*props.scale,
                  height: 100*props.scale,
                }
              }
            />
    }
    else
    {
      switch(device.current_status.level.status)
      {
        case 'empty':
          return <img
              src={(props.shared=='true') ? GasStorageEmptyShared : GasStorageEmpty}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 120*props.scale,
                  height: 100*props.scale,
                }
              }
            />
        case 'deplete':
          return <img
              src={(props.shared=='true') ? GasStorageDepleteShared : GasStorageDeplete}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 120*props.scale,
                  height: 100*props.scale,
                }
              }
            />
        case 'good':
          return <img
              src={(props.shared=='true') ? GasStorageGoodShared : GasStorageGood}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 120*props.scale,
                  height: 100*props.scale,
                }
              }
            />
        case 'full':
          return  <img
          src={(props.shared=='true') ? GasStorageFullShared : GasStorageFull}
          alt={device.title}
          loading="lazy"
          style={
            {
              width: 120*props.scale,
              height: 100*props.scale,
            }
          }
        />
      }
    }
  }
  else
  {
    if(device.status.activated==="false")
    {
      return <img
              src={(props.shared=='true') ? LPGTangDeactivatedShared : LPGTangDeactivated}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 80*props.scale,
                  height: 100*props.scale,
                }
              }
            />
    }
    else if(((device.current_status.pressures.hasOwnProperty('p1')) && (device.current_status.pressures.p1.status === "deplete")) && ((device.current_status.pressures.hasOwnProperty('p2')) && (device.current_status.pressures.p2.status === "deplete")))
    {
      if(device.status.online==='false')
      {
        return <img
        src={(props.shared=='true') ? LPGTang14Shared : LPGTang14}
        alt={device.title}
        loading="lazy"
        style={
          {
            width: 80*props.scale,
            height: 100*props.scale,
          }
        }
      />
      }
      else{
        return <img
              src={(props.shared=='true') ? LPGTang14OnlineShared : LPGTang14Online}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 80*props.scale,
                  height: 100*props.scale,
                }
              }
            />
      }
    }
    else if(((device.current_status.pressures.hasOwnProperty('p1')) && (device.current_status.pressures.p1.status === "deplete")) || ((device.current_status.pressures.hasOwnProperty('p2')) && (device.current_status.pressures.p2.status === "deplete")))
    {
      if(device.status.online==='false')
      {
        return <img
        src={(props.shared=='true') ? LPGTang12Shared : LPGTang12}
        alt={device.title}
        loading="lazy"
        style={
          {
            width: 80*props.scale,
            height: 100*props.scale,
          }
        }
      />
      }
      else{
        return <img
              src={(props.shared=='true') ? LPGTang12OnlineShared : LPGTang12Online}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 80*props.scale,
                  height: 100*props.scale,
                }
              }
            />
      }
            
    }
    else if(((device.current_status.pressures.hasOwnProperty('p1')) && (device.current_status.pressures.p1.status === "active")) || ((device.current_status.pressures.hasOwnProperty('p2')) && (device.current_status.pressures.p2.status === "active")))
    {
      if(device.status.online==='false')
      {
        return <img
        src={(props.shared=='true') ? LPGTangFullShared : LPGTangFull}
        alt={device.title}
        loading="lazy"
        style={
          {
            width: 80*props.scale,
            height: 100*props.scale,
          }
        }
      />
      }
      else{
        return <img
              src={(props.shared=='true') ? LPGTangFullOnlineShared : LPGTangFullOnline}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 80*props.scale,
                  height: 100*props.scale,
                }
              }
            />
      }
    }
    else if(((device.current_status.pressures.hasOwnProperty('p1')) && (device.current_status.pressures.p1.status === "n/a")) || ((device.current_status.pressures.hasOwnProperty('p2')) && (device.current_status.pressures.p2.status === "n/a")))
    {
        return <img
              src={(props.shared=='true') ? LPGTangDeactivatedNAShared : LPGTangDeactivatedNA}
              alt={device.title}
              loading="lazy"
              style={
                {
                  width: 80*props.scale,
                  height: 100*props.scale,
                }
              }
            />
    }
  }
}

  return (<div className="container">
          {
            (device) ? (
              <Paper elevation={0}>
                {getLPGTang()}
                {
                  props.showTitle ? (
                      <ImageListItemBar
                          sx={{justifyContent: 'left', alignItems: 'left'}}
                          title={<LinkButton onClick={e => showDevice(props.deviceId, props.uid)} >{device.title}</LinkButton>}
                          subtitle={<Box sx={{pl: 1}}>{moment(device.log_timestamp).fromNow()}</Box>}
                          position="below"
                    />
                  ):
                  (
                    <></>
                  )
                }
                
              </Paper>
            ):
            (
              <></>
            )
          }
        </div>);
}

export default DeviceStatus;
